module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12720/images/illustrations/sales-free.svg"